import React, { Component } from 'react';

import { SiteSelectorFormFooter } from './site-selector-form-footer';
import { SiteSelectorRadioGroup } from './site-selector-radio-group';

import Form from '@atlaskit/form';

export type SiteSelectorFormProps = {
  readonly sites: string[];

  readonly onNewSiteSelected: () => void;
  readonly onSiteSelected: (site: string) => void;
  readonly onSiteChanged: () => void;
  readonly onSwitchAccountClick: () => void;
  readonly onCancelClick: () => void;
  readonly fullScreenView?: boolean;
};

export class SiteSelectorForm extends Component<SiteSelectorFormProps> {
  public handleFormSubmit = (data: FormData) => {
    const { onNewSiteSelected, onSiteSelected } = this.props;

    if (!data.site || data.site === '') {
      onNewSiteSelected();
    } else {
      onSiteSelected(data.site);
    }
  };

  public renderFormContents = (
    formProps: Record<string, unknown>,
    submitting: boolean
  ) => {
    const {
      sites,
      onSwitchAccountClick,
      onCancelClick,
      onSiteChanged,
      fullScreenView
    } = this.props;

    return (
      <form {...formProps} name="site-selector">
        <SiteSelectorRadioGroup sites={sites} onSiteChanged={onSiteChanged} />
        <SiteSelectorFormFooter
          canSubmit={!submitting}
          onSwitchAccountClick={onSwitchAccountClick}
          onCancelClick={onCancelClick}
          fullScreenView={fullScreenView}
        />
      </form>
    );
  };

  public render() {
    return (
      <Form onSubmit={this.handleFormSubmit}>
        {({ formProps, submitting }: FormProps) =>
          this.renderFormContents(formProps, submitting)
        }
      </Form>
    );
  }
}

export type FormData = {
  readonly site: string;
};

export type FormProps = {
  readonly formProps: Record<string, unknown>;
  readonly submitting: boolean;
};
